import React from "react";
import TXT from "presentational/common/multinational/TXT";
import CommonGuideTooltipView from "presentational/common/modals/CommonGuideTooltipView";

function OutfitUnitTooltipView(props) {
  const { children } = props;

  return (
    <CommonGuideTooltipView
      needClose={false}
      needCountUp={false}
      message={<TXT name="msg_tooltipClickNormalBtn" />}
      placement={"top"}
      arrow
      backgroundDesign={"primary"}
      displayForGuest
    >
      {children}
    </CommonGuideTooltipView>
  );
}

export default OutfitUnitTooltipView;
